module.exports = __webpack_public_path__ + "static/media/onboarding-food-min.4b835eb5.jpg";